/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState } from 'react';
import * as THREE from "three";
import { const_var, params } from '../../../../../../redux/reducers/reducer';
import { delModel, extrudeSettings, railModel, textureAnisotropy } from '../../../../../../utils/Functions';
import { CSG } from '../../../../../../assets/libs/csg-lib';
import { ReflectLegTextureNX, ReflectLegTextureNY, ReflectLegTextureNZ, ReflectLegTexturePX, ReflectLegTexturePY, ReflectLegTexturePZ, TrussRailTextureImg } from '../../../../../../utils/Textures';
import { useThree } from '@react-three/fiber';
import { setMainTrussPosInfo } from '../../../../../../action';
import { useDispatch, useSelector } from 'react-redux';
import { controls } from '../../../../../../redux/reducers/common/eventReducer';
import { useTexture } from '@react-three/drei';

const Legs = () => {    
    const dispatch = useDispatch();
    const { gl } = useThree();

    const [isMapLoad, setIsMapLoad] = useState(false);
    const nMap = useTexture( process.env.REACT_APP_BASE_URL+TrussRailTextureImg);

    const [offset, setOffset] = useState(false);

    const railWidth = 0.2;
    const railHeight = 0.3;
    const connectRailWidth = 0.3;
    const connectRailHeight = 0.2;
    const sideEdgeSlopeRailLength = 2.5;
    const sideEdgeSlopeRailAlpha = Math.PI / 3.2;
    const verticalRailWidth = 0.1;
    const verticalRailHeight = 0.2;

    let meshDelModel_CSG = {};
    const wallValueArr = ['front', 'back', 'left', 'right', 'backStorageFront', 'backStorageBack', 'backStorageLeft', 'backStorageRight', 'leftStorageFront', 'rightStorageFront'];

    wallValueArr.map((item) => {
        const meshDelModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(delModel(item, 'leg'), extrudeSettings(3)),
            new THREE.MeshStandardMaterial({ color: 'red' })
        )
        const meshDelModel_Temp = meshDelModel.clone();

        if (item === 'front' || item === 'back'|| item === 'backStorageFront' || item === 'backStorageBack') {
            meshDelModel_Temp.position.set(0, 0, -1.5)
        } else {
            meshDelModel_Temp.rotateY(-Math.PI / 2)
            meshDelModel_Temp.position.set(1.5, 0, -params.endStoragePositionZ)
        }
        meshDelModel_Temp.updateMatrix();
        meshDelModel_Temp.updateMatrixWorld();
        
        const mesh_CSG = CSG.fromMesh(meshDelModel_Temp);
        
        meshDelModel_CSG = { ...meshDelModel_CSG,  [item]: mesh_CSG };
        
        return null;
    })

    const trussTexture = useMemo(() => {
        let envMap = const_var.envIMG
        textureAnisotropy(gl, envMap, 1, 1, 0)
        return envMap
    }, []);
    
    const norMap = useMemo(() => {
        let normalMap = nMap
        textureAnisotropy(gl, normalMap, 1, 1, Math.PI / 2)
        return normalMap
    }, []);

    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!==undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s, params.fourth_center_cost])


    const trussModelPosInfoArr = useMemo(() => {
        let count, distance = 0;
        
        const initDistance = (params.p_u_t);
        const tempCount = Math.floor((params.p_u_t) / initDistance);
        if ((params.p_u_t) === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if ((params.p_u_t) - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = (params.p_u_t) / count;
        } else {
            count = tempCount + 1;
            distance = (params.p_u_t) / count;
        }
        
        const posInfoArr = Array.from({ length: count + 1 }, (_, index) => distance * index - params.p_d / 2)
        return posInfoArr
    }, [params.p_d, params.p_u_t])

    // useMemo(() => {
    //     if (trussModelPosInfoArr.length > 0) dispatch(setMainTrussPosInfo(trussModelPosInfoArr));
    // }, [trussModelPosInfoArr])

    const trussType = useMemo(() => {
        return (params.p_w > 30) ? params.trussType : (params.p_w > 24 && params.p_w <= 30) ? "TWCT" : "";
    }, [params.p_w, params.trussType]) ;

    const roofRailDistanceY = useMemo(() => {
        if(trussType === "LST"  || trussType === "ECT" || trussType === "RNT") return 0.7;
        else if(trussType === "ACDT" || trussType === "CTCT" || trussType === "QCT") return 1;
        else if(trussType === "TWCT") return 0;
        else return 0.7
    }, [trussType])

    const dynamicHeight = useMemo(() => {
        return params.singleSlope && params.freeStandingSide === "left" ? (params.p_h - ((params.p_r_p/12)*(params.p_w))) : params.p_r_s === 1 ? params.p_h + 0.28  : params.p_h;
    }, [params.singleSlope, params.freeStandingSide, params.p_h, params.p_r_p, params.p_w, params.p_r_s]) 

    const dynamicHeightRight = useMemo(() => {
        return params.singleSlope && params.freeStandingSide === "right" ? (params.p_h + ((params.p_r_p/12)*(params.p_w))) - 0.1 : params.p_r_s === 1 ? params.p_h + 0.28 : params.p_h;
    }, [params.singleSlope, params.freeStandingSide, params.p_h, params.p_r_p, params.p_w, params.p_r_s]) 

    const outInDistance = useMemo(() => {
        return (const_var.legstype === "double") ? 0.21 : (const_var.legstype === "ladder") ? 0.5 : 0;
    }, [const_var.legstype]) 

    const connectRailDataArr = useMemo(() => {
        let dataInfoArray = [];
        let count, distance;

        let initDistance = 2;
        const tempCount = Math.floor(params.p_h / initDistance);
        if (params.p_h === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_h - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = params.p_h / count;
        } else {
            count = tempCount + 1;
            distance = params.p_h / count;
        }

        for (let i = 0; i < count; i++) {            
            const pos_x = params.p_w / 2 - railWidth / 2;
            const pos_y = distance * i + railWidth / 2;

            const tempInfoObj = {
                pos_x: pos_x,
                pos_y: pos_y,
                length: outInDistance,
            }

            dataInfoArray.push(tempInfoObj);
        }

        return dataInfoArray
    }, [params.p_h, params.p_w])
    
    const frontBackPillarRailDataArr = useMemo(() => {
        let dataInfoArray = []
        let endCrossBracingLegs = []
        let endCrossBracingHorizonTruss = []
        let endCrossBracingSlopeTruss = []
        let count, distance = 0;
        let horizonTrussCount = 0
        
        const initDistance = legDistance;
        const tempCount = Math.floor(params.p_w / initDistance);
        if (params.p_w === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_w - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = params.p_w / count;
        } else {
            count = tempCount + 1;
            distance = params.p_w / count;
        }
        
        const horizonTrussDistance = (distance / 2) / 4 * 5;
        const tempHorizonTrussCount = Math.floor(params.p_h / horizonTrussDistance)
        const slopeTrussAngle = Math.atan((distance / 2) / (horizonTrussDistance + railHeight))
        const slopeTrussLength = Math.sqrt(Math.pow(horizonTrussDistance, 2) + Math.pow((distance / 2), 2))

        if (params.p_h > horizonTrussDistance * tempHorizonTrussCount) {
            horizonTrussCount = tempHorizonTrussCount + 1;
        } else {
            horizonTrussCount = tempHorizonTrussCount;
        }
        
        for (let i = 1; i < count; i++) {
            const pos_x = distance * i - params.p_w / 2;
            let shortLength
            let longLength 
            let length
            const isLeftFreeStanding = params.singleSlope && params.freeStandingSide === "left";
            const isRightFreeStanding = params.singleSlope && params.freeStandingSide === "right";

            if(trussType === "LST" || trussType === "RNT"){
                shortLength = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12) - roofRailDistanceY - railWidth / 2;;
                longLength = params.p_h + (params.p_w / 2 * (params.p_r_p / 12)) - ((params.p_w / 3 * (params.p_r_p / 12))) - roofRailDistanceY - railWidth / 2;
            }else if(trussType === "ACDT" || trussType === "CTCT" || trussType === "ECT" || trussType === "QCT" || trussType === "TWCT"){
                shortLength = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12) - roofRailDistanceY - railWidth / 2;;
                longLength = params.p_h + (params.p_w / 2 * (params.p_r_p / 12)) - ((params.p_w / 4 * (params.p_r_p / 12))) - roofRailDistanceY - railWidth / 2;
            }else if(trussType === "ACT"){
                shortLength = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12) - roofRailDistanceY - railWidth / 2;;
                longLength =  params.p_h + (params.p_w / 2 * (2 / 5)) * (params.p_r_p / 12) - roofRailDistanceY;
            }else if(trussType === "SBST"){
                shortLength = params.p_h
                longLength =  params.p_h
            }else{
                shortLength = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12);
                longLength = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12);
            }

            // if (params.p_w > 24) {
            //     length = Math.abs(pos_x) > params.p_w / 4 ? shortLength : longLength;
            // } else 
            if (isLeftFreeStanding) {
                length = params.p_h - (params.p_w * (params.p_r_p / 12)) + (distance * i) * (params.p_r_p / 12) - railWidth / 2;
            } else if (isRightFreeStanding) {
                length = params.p_h + (distance * i) * (params.p_r_p / 12) - railWidth / 2;
            } else if (params.p_r_s === 1) {
                length = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12) + railWidth / 2;
            } else {
                length = params.p_h + (params.p_w / 2 - Math.abs(pos_x)) * (params.p_r_p / 12) - railWidth / 2;
            }
            
            const tempInfoObj ={
                pos_x: pos_x,
                length: length
            }
            
            dataInfoArray.push(tempInfoObj);
        }
    
        
        // front end cross bracing legs and horizon, slope truss
        
        for(let i = 0; i < 2; i++) {
            let pos_x;
            
            const length = params.p_h + (distance / 2) * (params.p_r_p / 12);
            if(i === 0) {
                pos_x = -params.p_w / 2 + distance / 2
                for(let j = 0; j < horizonTrussCount; j++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y + railWidth / 2,
                        length: distance / 2
                    }
                    endCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                }
                for(let k = 0; k < horizonTrussCount - 1; k++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y,
                        length: slopeTrussLength,
                        rotationZ : slopeTrussAngle
                    }
                    endCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            } else if (i === 1) {
                let pos_y;
                pos_x = params.p_w / 2 - distance / 2
                for(let j = 0; j < horizonTrussCount; j++) {
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_x: pos_x + distance / 2,
                        pos_y: pos_y + railWidth / 2,
                        length: distance / 2
                    }
                    endCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                    
                }
                for(let k = 0; k < horizonTrussCount - 1; k++) {
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_x: pos_x,
                        pos_y: pos_y,
                        length: slopeTrussLength,
                        rotationZ : -slopeTrussAngle
                    }
                    endCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            }

            const tempLegInfoObj ={
                pos_x: pos_x,
                length: length
            }
            
            
            endCrossBracingLegs.push(tempLegInfoObj)
        }



        return {
            dataInfoArray,
            endCrossBracingLegs,
            endCrossBracingHorizonTruss,
            endCrossBracingSlopeTruss
        };
    }, [params.p_h, params.p_w, params.p_r_p, params.p_r_s, legDistance,trussType, params.singleSlope && params.freeStandingSide === "left", roofRailDistanceY,])

    const sidePillarRailDataArr = useMemo(() => {
        
        let sideCrossBracingHorizonTruss = []
        let sideCrossBracingSlopeTruss = []
        let count, distance = 0;
        let horizonTrussCount = 0
        
        const initDistance = legDistance;
        const tempCount = Math.floor(params.p_d / initDistance);
        if (params.p_d === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else if (params.p_d - tempCount * initDistance <= initDistance / 2) {
            count = tempCount;
            distance = params.p_d / count;
        } else {
            count = tempCount + 1;
            distance = params.p_d / count;
        }
        
        const horizonTrussDistance = (distance / 2) / 4 * 5;
        const tempHorizonTrussCount = Math.floor(params.p_h / horizonTrussDistance)
        const slopeTrussAngle = Math.atan((distance) / (horizonTrussDistance + railHeight / 2))
        const slopeTrussLength = Math.sqrt(Math.pow(horizonTrussDistance, 2) + Math.pow((distance), 2))

        if (params.p_h > horizonTrussDistance * tempHorizonTrussCount) {
            horizonTrussCount = tempHorizonTrussCount + 1;
        } else {
            horizonTrussCount = tempHorizonTrussCount;
        }
        
        // front end cross bracing legs and horizon, slope truss
        
        for(let i = 0; i < 2; i++) {
            let pos_Z;
            
            if(i === 0) {
                pos_Z = -params.p_d / 2
                for(let j = 1; j < horizonTrussCount; j++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y + railWidth / 2,
                        length: distance
                    }
                    sideCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                }
                for(let k = 0; k < horizonTrussCount - 1; k++) {
                    let pos_y;
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_Z: pos_Z + distance,
                        pos_y: pos_y,
                        length: slopeTrussLength,
                        rotationX : -(Math.PI / 2 + slopeTrussAngle)
                    }
                    sideCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            } else if (i === 1) {
                let pos_y;
                pos_Z = params.p_d / 2 - distance
                for(let j = 1; j < horizonTrussCount; j++) {
                    pos_y = horizonTrussDistance * j
                    const tempHorizonTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y + railWidth / 2,
                        length: distance
                    }
                    sideCrossBracingHorizonTruss.push(tempHorizonTrussInfoObj)
                    
                }
                for(let k = 0; k < horizonTrussCount - 1; k++) {
                    pos_y = horizonTrussDistance * k
                    const tempSlopeTrussInfoObj = {
                        pos_Z: pos_Z,
                        pos_y: pos_y,
                        length: slopeTrussLength,
                        rotationX : -(Math.PI / 2 - slopeTrussAngle)
                    }
                    sideCrossBracingSlopeTruss.push(tempSlopeTrussInfoObj)
                }
            }
            
        }



        return {
            sideCrossBracingHorizonTruss,
            sideCrossBracingSlopeTruss
        };
    }, [params.p_h, params.p_d, params.p_r_p, legDistance,trussType, params.singleSlope && params.freeStandingSide === "left", roofRailDistanceY])

    /************** cutting hole using CSG ***************/

    const CSGFrontBackPillarRailModelArr = useMemo(() => {
        let backModelArr = [];
        let backStorageModelArr = [];

        const modelShape = railModel(railWidth, railHeight);
        frontBackPillarRailDataArr.dataInfoArray.map((item) => {    
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            let meshBackPillarRailModel_Temp = meshPillarRailModel.clone();    
            meshBackPillarRailModel_Temp.position.set(item.pos_x, 0, 0);
            meshBackPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshBackPillarRailModel_Temp.updateMatrix();
            meshBackPillarRailModel_Temp.updateMatrixWorld();
            const meshBackPillarRailModel_CSG = CSG.fromMesh(meshBackPillarRailModel_Temp);

            let meshBackStoragePillarRailModel_Temp = meshPillarRailModel.clone();    
            meshBackStoragePillarRailModel_Temp.position.set(item.pos_x, 0, 0);
            meshBackStoragePillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshBackStoragePillarRailModel_Temp.updateMatrix();
            meshBackStoragePillarRailModel_Temp.updateMatrixWorld();
            const meshBackStoragePillarRailModel_CSG = CSG.fromMesh(meshBackStoragePillarRailModel_Temp);

            const backPillarRailModel_CSG = meshBackPillarRailModel_CSG.subtract(meshDelModel_CSG.backStorageBack);
            const backStoragePillarRailModel_CSG = meshBackStoragePillarRailModel_CSG.subtract(meshDelModel_CSG.backStorageFront);

            const CSGBackPillarRailModel = CSG.toMesh(
                backPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGBackStoragePillarRailModel = CSG.toMesh(
                backStoragePillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            backModelArr.push(CSGBackPillarRailModel);
            backStorageModelArr.push(CSGBackStoragePillarRailModel);

            return null;
        })

        return {  backModelArr, backStorageModelArr };
    }, [frontBackPillarRailDataArr, meshDelModel_CSG.backStorageBack, meshDelModel_CSG.front, meshDelModel_CSG.backStorageFront])

    const CSGFrontBackBottomRailData = useMemo(() => {
        const modelShape = railModel(railHeight, railWidth);

        const meshBottomRailModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(modelShape, extrudeSettings(params.p_w - 2 * railWidth)),
            new THREE.MeshStandardMaterial({ color: 'pink' })
        )
        const meshStorageBottomRailModel = new THREE.Mesh(
            new THREE.ExtrudeGeometry(modelShape, extrudeSettings(params.p_w - 2 * railWidth)),
            new THREE.MeshStandardMaterial({ color: 'pink' })
        )

        let meshBackBottomRailModel_Temp = meshBottomRailModel.clone();    
        meshBackBottomRailModel_Temp.position.set(-params.p_w / 2 +  + railWidth, railWidth / 2, 0);
        meshBackBottomRailModel_Temp.rotateY(Math.PI / 2);
        meshBackBottomRailModel_Temp.updateMatrix();
        meshBackBottomRailModel_Temp.updateMatrixWorld();
        const meshBackBottomRailModel_CSG = CSG.fromMesh(meshBackBottomRailModel_Temp);

        let meshBackStorageBottomRailModel_Temp = meshStorageBottomRailModel.clone();    
        meshBackStorageBottomRailModel_Temp.position.set(-params.p_w / 2 + railWidth, railWidth / 2, 0);
        meshBackStorageBottomRailModel_Temp.rotateY(Math.PI / 2);
        meshBackStorageBottomRailModel_Temp.updateMatrix();
        meshBackStorageBottomRailModel_Temp.updateMatrixWorld();
        const meshBackStorageBottomRailModel_CSG = CSG.fromMesh(meshBackStorageBottomRailModel_Temp);

        const backBottomRailModel_CSG = meshBackBottomRailModel_CSG.subtract(meshDelModel_CSG.back);
        const backStorageBottomRailModel_CSG = meshBackStorageBottomRailModel_CSG.subtract(meshDelModel_CSG.backStorageFront);
       

        const CSGBackBottomRailModel = CSG.toMesh(
            backBottomRailModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        const CSGBackStorageBottomRailModel = CSG.toMesh(
            backStorageBottomRailModel_CSG,
            new THREE.Matrix4(),
            new THREE.MeshStandardMaterial({ color: 'blue' })
        )

        return { CSGBackBottomRailModel, CSGBackStorageBottomRailModel};
    }, [params.p_w, meshDelModel_CSG.back, meshDelModel_CSG.front, meshDelModel_CSG.backStorageFront])

    const CSGSideRailGroupModelArr = useMemo(() => {
        let leftModelArr = [];
        let leftStorageModelArr = [];
        let leftConnectModelArr = [];
        let rightModelArr = [];
        let rightStorageModelArr = [];
        let rightConnectModelArr = [];
        let leftSideCrossBracingHorizonTrussArr = [];
        let rightSideCrossBracingHorizonTrussArr = [];
        let leftSideCrossBracingSlopeTrussArr = [];
        let rightSideCrossBracingSlopeTrussArr = [];
        
        const modelShape = railModel(railWidth, railHeight);
        const modelShapeConnect = railModel(railHeight, railWidth);
        trussModelPosInfoArr.map((pos_z, index) => {    
            const meshOuterPillarRailModelL = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(dynamicHeight )),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshInnerPillarRailModelL = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(dynamicHeight + outInDistance * params.p_r_p / 12 - 0.15 )),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshOuterPillarRailModelR = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings((params.singleSlope ) ? params.p_h - 0.2 : dynamicHeightRight)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

            const meshInnerPillarRailModelR = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings((params.singleSlope ) ? dynamicHeight + (params.p_w - outInDistance) * params.p_r_p / 12 - 0.2 : dynamicHeightRight + 0.06)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )

           //--- left -- outer
        
           let meshLeftOuterPillarRailModel_Temp = meshOuterPillarRailModelL.clone();    
           meshLeftOuterPillarRailModel_Temp.position.set(0.005, 0, pos_z);
           meshLeftOuterPillarRailModel_Temp.rotateX(-Math.PI / 2);
           meshLeftOuterPillarRailModel_Temp.updateMatrix();
           meshLeftOuterPillarRailModel_Temp.updateMatrixWorld();
           const meshLeftOuterPillarRailModel_CSG = CSG.fromMesh(meshLeftOuterPillarRailModel_Temp);

           const leftOuterPillarRailModel_CSG = meshLeftOuterPillarRailModel_CSG.subtract(meshDelModel_CSG.left);
           const CSGLeftOuterPillarRailModel = CSG.toMesh(
               leftOuterPillarRailModel_CSG,
               new THREE.Matrix4(),
               new THREE.MeshStandardMaterial({ color: 'blue' })
           )

           //--- left -- inner

           let meshLeftInnerPillarRailModel_Temp = meshInnerPillarRailModelL.clone();    
           meshLeftInnerPillarRailModel_Temp.position.set(0.005, 0, pos_z);
           meshLeftInnerPillarRailModel_Temp.rotateX(-Math.PI / 2);
           meshLeftInnerPillarRailModel_Temp.updateMatrix();
           meshLeftInnerPillarRailModel_Temp.updateMatrixWorld();
           const meshLeftInnerPillarRailModel_CSG = CSG.fromMesh(meshLeftInnerPillarRailModel_Temp);

           const leftInnerPillarRailModel_CSG = meshLeftInnerPillarRailModel_CSG.subtract(meshDelModel_CSG.left);
           const CSGLeftInnerPillarRailModel = CSG.toMesh(
               leftInnerPillarRailModel_CSG,
               new THREE.Matrix4(),
               new THREE.MeshStandardMaterial({ color: 'blue' })
           )

           connectRailDataArr.map((item_connect) => {
               const meshLeftConnectRailModel = new THREE.Mesh(
                   new THREE.ExtrudeGeometry(modelShapeConnect, extrudeSettings(outInDistance)),
                   new THREE.MeshStandardMaterial({ color: 'pink' })
               )
               let meshLeftConnectRailModel_Temp = meshLeftConnectRailModel.clone();    
               meshLeftConnectRailModel_Temp.position.set(0, item_connect.pos_y, pos_z);
               meshLeftConnectRailModel_Temp.rotateY(Math.PI / 2);
               meshLeftConnectRailModel_Temp.updateMatrix();
               meshLeftConnectRailModel_Temp.updateMatrixWorld();
               const meshLeftConnectRailModel_CSG = CSG.fromMesh(meshLeftConnectRailModel_Temp);
   
               const leftConnectRailModel_CSG = meshLeftConnectRailModel_CSG.subtract(meshDelModel_CSG.left);
               const CSGLeftConnectRailModel = CSG.toMesh(
                   leftConnectRailModel_CSG,
                   new THREE.Matrix4(),
                   new THREE.MeshStandardMaterial({ color: 'blue' })
               )
               
               if((params.singleSlope && params.freeStandingSide === "left" && (item_connect.pos_y < params.p_h - ((params.p_r_p/12) * params.p_w))) || ( !params.singleSlope)) leftConnectModelArr.push(CSGLeftConnectRailModel);
               
               return null;
           })

            //--- right -- outer

            let meshRightOuterPillarRailModel_Temp = meshOuterPillarRailModelR.clone();    
            meshRightOuterPillarRailModel_Temp.position.set(-0.005, 0, pos_z);
            meshRightOuterPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshRightOuterPillarRailModel_Temp.updateMatrix();
            meshRightOuterPillarRailModel_Temp.updateMatrixWorld();
            const meshRightOuterPillarRailModel_CSG = CSG.fromMesh(meshRightOuterPillarRailModel_Temp);

            const rightOuterPillarRailModel_CSG = meshRightOuterPillarRailModel_CSG.subtract(meshDelModel_CSG.right);
            const CSGRightOuterPillarRailModel = CSG.toMesh(
                rightOuterPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            //--- right -- inner

            let meshRightInnerPillarRailModel_Temp = meshInnerPillarRailModelR.clone();    
            meshRightInnerPillarRailModel_Temp.position.set(-0.005, 0, pos_z);
            meshRightInnerPillarRailModel_Temp.rotateX(-Math.PI / 2);
            meshRightInnerPillarRailModel_Temp.updateMatrix();
            meshRightInnerPillarRailModel_Temp.updateMatrixWorld();
            const meshRightInnerPillarRailModel_CSG = CSG.fromMesh(meshRightInnerPillarRailModel_Temp);

            const rightInnerPillarRailModel_CSG = meshRightInnerPillarRailModel_CSG.subtract(meshDelModel_CSG.right);
            const CSGRightInnerPillarRailModel = CSG.toMesh(
                rightInnerPillarRailModel_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )

            connectRailDataArr.map((item_connect) => {
                const meshRightConnectRailModel = new THREE.Mesh(
                    new THREE.ExtrudeGeometry(modelShapeConnect, extrudeSettings(outInDistance)),
                    new THREE.MeshStandardMaterial({ color: 'pink' })
                )
                let meshRightConnectRailModel_Temp = meshRightConnectRailModel.clone();    
                meshRightConnectRailModel_Temp.position.set(0, item_connect.pos_y, pos_z);
                meshRightConnectRailModel_Temp.rotateY(-Math.PI / 2);
                meshRightConnectRailModel_Temp.updateMatrix();
                meshRightConnectRailModel_Temp.updateMatrixWorld();
                const meshRightConnectRailModel_CSG = CSG.fromMesh(meshRightConnectRailModel_Temp);
    
                const rightConnectRailModel_CSG = meshRightConnectRailModel_CSG.subtract(meshDelModel_CSG.right);
                const CSGRightConnectRailModel = CSG.toMesh(
                    rightConnectRailModel_CSG,
                    new THREE.Matrix4(),
                    new THREE.MeshStandardMaterial({ color: 'blue' })
                )
                rightConnectModelArr.push(CSGRightConnectRailModel);
                
                return null;
            })

            leftModelArr.push({
                outer: CSGLeftOuterPillarRailModel,
                inner: CSGLeftInnerPillarRailModel
            });
            rightModelArr.push({
                outer: CSGRightOuterPillarRailModel,
                inner: CSGRightInnerPillarRailModel
            });


            return null;
        })

        sidePillarRailDataArr.sideCrossBracingHorizonTruss.map((item) => {    
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshLeftSideCrossBracingHorizonTruss = meshPillarRailModel.clone();    
            meshLeftSideCrossBracingHorizonTruss.position.set(0, item.pos_y, item.pos_Z);
            meshLeftSideCrossBracingHorizonTruss.updateMatrix();
            meshLeftSideCrossBracingHorizonTruss.updateMatrixWorld();
            const meshLeftSideCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingHorizonTruss);
            const meshRightSideCrossBracingHorizonTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingHorizonTruss);

            const leftSideCrossBracingHorizonTruss_CSG = meshLeftSideCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.left);
            const rightSideCrossBracingHorizonTruss_CSG = meshRightSideCrossBracingHorizonTruss_CSG.subtract(meshDelModel_CSG.right);

            const CSGLeftSideCrossBracingHorizonTruss = CSG.toMesh(
                leftSideCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGRightSIdeCrossBracingHorizonTruss = CSG.toMesh(
                rightSideCrossBracingHorizonTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            leftSideCrossBracingHorizonTrussArr.push(CSGLeftSideCrossBracingHorizonTruss);
            rightSideCrossBracingHorizonTrussArr.push(CSGRightSIdeCrossBracingHorizonTruss);

            return null;
        })

        sidePillarRailDataArr.sideCrossBracingSlopeTruss.map((item) => {    
            const meshPillarRailModel = new THREE.Mesh(
                new THREE.ExtrudeGeometry(modelShape, extrudeSettings(item.length)),
                new THREE.MeshStandardMaterial({ color: 'pink' })
            )
        
            let meshLeftSideCrossBracingSlopeTruss = meshPillarRailModel.clone();    
            meshLeftSideCrossBracingSlopeTruss.position.set(0, item.pos_y, item.pos_Z);
            meshLeftSideCrossBracingSlopeTruss.rotateX(item.rotationX);
            meshLeftSideCrossBracingSlopeTruss.updateMatrix();
            meshLeftSideCrossBracingSlopeTruss.updateMatrixWorld();
            const meshLeftSideCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingSlopeTruss);
            const meshRightSideCrossBracingSlopeTruss_CSG = CSG.fromMesh(meshLeftSideCrossBracingSlopeTruss);

            const leftSideCrossBracingSlopeTruss_CSG = meshLeftSideCrossBracingSlopeTruss_CSG.subtract(meshDelModel_CSG.left);
            const rightSideCrossBracingSlopeTruss_CSG = meshRightSideCrossBracingSlopeTruss_CSG.subtract(meshDelModel_CSG.right);

            const CSGLeftSideCrossBracingSlopeTruss = CSG.toMesh(
                leftSideCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
            const CSGRightSIdeCrossBracingSlopeTruss = CSG.toMesh(
                rightSideCrossBracingSlopeTruss_CSG,
                new THREE.Matrix4(),
                new THREE.MeshStandardMaterial({ color: 'blue' })
            )
        
            leftSideCrossBracingSlopeTrussArr.push(CSGLeftSideCrossBracingSlopeTruss);
            rightSideCrossBracingSlopeTrussArr.push(CSGRightSIdeCrossBracingSlopeTruss);

            return null;
        })

        return {
            leftModelArr,
            leftConnectModelArr,
            rightModelArr,
            rightConnectModelArr,
            leftStorageModelArr,
            rightStorageModelArr,
            leftSideCrossBracingHorizonTrussArr,
            rightSideCrossBracingHorizonTrussArr,
            leftSideCrossBracingSlopeTrussArr,
            rightSideCrossBracingSlopeTrussArr
        };
    }, [params.p_h, connectRailDataArr, meshDelModel_CSG.left, meshDelModel_CSG.right, trussModelPosInfoArr, meshDelModel_CSG.leftStorageFront, meshDelModel_CSG.rightStorageFront])
    /****************************************** *********/

    const roofStylePosOffset = useMemo(() => {
        return params.p_r_s === 1 ? 0.2 : 0;
    }, [params.p_r_s]) 

    const roofAlpha = useMemo(() => {
        return Math.atan(params.p_r_p / 12)
    }, [params.p_r_p]) 

    const sideEdgeSlopeRailPosY = useMemo(() => {
        return params.p_h - (sideEdgeSlopeRailLength * Math.sin(sideEdgeSlopeRailAlpha) - (sideEdgeSlopeRailLength * Math.cos(sideEdgeSlopeRailAlpha)) * Math.tan(roofAlpha)) + roofStylePosOffset * 2 - (params.p_r_s === 1 ? params.p_r_p / 60 : 0);
    }, [params.p_h, roofAlpha, roofStylePosOffset, params.p_r_s, params.p_r_p]);

    const singleSlopeBracesHeight = useMemo(() => {
        return (params.singleSlope && params.freeStandingSide === "left") ? sideEdgeSlopeRailPosY - ((params.p_r_p/12)*(params.p_w)) : sideEdgeSlopeRailPosY
    }, [params.singleSlope, params.freeStandingSide, sideEdgeSlopeRailPosY, params.p_r_p, params.p_w])

    const pos_x = useMemo(() => {
        return -params.p_w / 2 + connectRailWidth / 4 + roofStylePosOffset;
    }, [params.p_w, roofStylePosOffset]) 

    const pos_y = useMemo(() => {
        return dynamicHeight - connectRailHeight / 2 + roofStylePosOffset * 2 - ((params.p_r_s === 1) ? 0.3 : 0)
    }, [dynamicHeight, roofStylePosOffset, params.p_r_s]) 

    const baseSquared = useMemo(() => {
        return params.p_w ** 2;
    }, [params.p_w]) 

    const heightSquared = useMemo(() => {
        return ((params.p_r_p/12)*(params.p_w)) ** 2;
    }, [params.p_r_p, params.p_w])

    const hypotenuseLength = useMemo(() => {
        return Math.sqrt((baseSquared + heightSquared));
    }, [baseSquared, heightSquared]) 

    const roofRailLength = useMemo(() => {
        return (params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right")) ? hypotenuseLength - 0.05 : Math.sqrt(Math.pow((params.p_w / 2 - roofStylePosOffset), 2) + Math.pow((params.p_w / 2 - roofStylePosOffset) * params.p_r_p / 12, 2));
    }, [params.singleSlope, params.freeStandingSide, hypotenuseLength, params.p_w, roofStylePosOffset, params.p_r_p]) 

    const roofRailData = useMemo(() => {
        return {
            alpha: roofAlpha,
            length: roofRailLength,
            pos_x: pos_x,
            pos_y: pos_y
        }
    }, [roofAlpha, roofRailLength, pos_x, pos_y]) 

    let rightBraceHeight = useMemo(() => {
        if(params.singleSlope && params.freeStandingSide === "left"){
            return params.p_h - (sideEdgeSlopeRailLength-(sideEdgeSlopeRailLength/3.2)) - ((params.p_r_p/12)*(3))
        }else if((params.singleSlope && params.freeStandingSide === "right")){
            return params.p_h + ((params.p_r_p/12)*(params.p_w)) - (sideEdgeSlopeRailLength-(sideEdgeSlopeRailLength/3.2)) - ((params.p_r_p/12)*(3)) 
        }else{
            return sideEdgeSlopeRailPosY
        }
    }, [params.singleSlope, params.freeStandingSide, params.p_h, params.p_r_p, params.p_w, sideEdgeSlopeRailPosY])

    let overlapOffset = useMemo(() => {
        if(params.p_b_t === 27) {
            return -0.02 + (2 - params.p_r_p) * (-0.35 / 4)
        } else{
            return 0
        }
    }, [params.p_b_t, params.p_r_p])    

    const connerOffset = useMemo(() => {
        return params.p_b_t === 27 ? 0.04 : 0.035; 
    }, [params.p_b_t]) 

    const height = useMemo(() => {
        let height = 0
        if(params.singleSlope){
            height = params.p_h - params.p_w * params.p_r_p / 12;
        } else {
            height = params.p_h;
        }
        
        return height
    }, [params.p_r_p, params.p_w, params.p_h, params.singleSlope])
    
    const legModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-verticalRailWidth / 2, -verticalRailHeight / 2);
        model.lineTo(-verticalRailWidth / 2, verticalRailHeight / 2);
        model.lineTo(verticalRailWidth / 2, verticalRailHeight / 2);
        model.lineTo(verticalRailWidth / 2, -verticalRailHeight / 2);
        model.closePath();
        
        return model;
    }, [])
    
    const modelPosYArr = useMemo(() => {
        let count, distance = 0;
        const initDistance = 4;
        
        const tempCount = Math.floor(height / initDistance);
        if (height === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else {
            count = tempCount + 1;
            distance = height / count;
        }
        
        const tempPosInfoArr = Array.from({ length: count + 2 }, (_, index) => distance * index)
        const posInfoArr = tempPosInfoArr.slice(1, -1);
        
        return posInfoArr
    }, [params.p_h, height])

    const frontBackModelPosYArr = useMemo(() => {
        let count, distance = 0;
        
        const initDistance = 4;
        const tempCount = Math.floor(( params.p_w * params.p_r_p / 12) / initDistance);
        const tempCount1 = Math.floor(height / initDistance);
        const count1 = tempCount1 + 1;
        const distance1 = height / count1;
        if (params.p_w * params.p_r_p / 12 === tempCount * initDistance) {
            count = tempCount;
            distance = initDistance;
        } else {
            count = tempCount + 1;
            distance = distance1
        }
        
        const tempPosInfoArr = Array.from({ length: count  }, (_, index) => distance * index)
        const posInfoArr = tempPosInfoArr.slice(1);
        
        return posInfoArr
    }, [params.p_h, height, params.p_w, params.p_r_p])

    const directionInfoArr = useMemo(() => {
        const wallWhiteSpace = 0.127
        let isShowBackStorageFront = false;
        let isShowBackStorageBack = false;
        let isShowBackStorageLeft = false;
        let isShowBackStorageRight = false;

        if (params.endStoragePositionZ !== 0) isShowBackStorageBack = true;
        if (params.endStoragePositionZ !== params.p_d - parseInt(params.p_u_t)) isShowBackStorageFront = true;
        if (params.p_l_w !== 'Close') isShowBackStorageLeft = true;
        if (params.p_r_w !== 'Close') isShowBackStorageRight = true;
        
        const dataArr = [
            {
                direction: 'backStorageFront',
                isShow: isShowBackStorageFront,
                size: params.p_w - wallWhiteSpace * 4,
                angle: Math.PI / 2,
                pos_x: -params.p_w / 2 + wallWhiteSpace * 2,
                pos_z: -0.06,
                end_pos_x: 0,
                end_pos_z: -params.p_d / 2 + parseInt(params.p_u_t) - 0.15 + 0.1,
            },
            {
                direction: 'backStorageBack',
                isShow: isShowBackStorageBack,
                size: params.p_w - wallWhiteSpace * 4,
                angle: Math.PI / 2,
                pos_x: -params.p_w / 2 + wallWhiteSpace * 2,
                pos_z: 0.06,
                end_pos_x: 0,
                end_pos_z: -params.p_d / 2 - 0.1,
            },
            {
                direction: 'backStorageLeft',
                isShow: isShowBackStorageLeft,
                size: parseInt(params.p_u_t),
                angle: 0,
                pos_x: 0,
                pos_z: -params.p_d / 2,
                end_pos_x: -params.p_w / 2 + 0.11,
                end_pos_z: 0,
            },
            {
                direction: 'backStorageRight',
                isShow: isShowBackStorageRight,
                size: parseInt(params.p_u_t),
                angle: 0,
                pos_x: 0,
                pos_z: -params.p_d / 2,
                end_pos_x: params.p_w / 2 - 0.1,
                end_pos_z: 0,
            },
          
        ]
        
        return dataArr;
    }, [params.p_w, params.p_d, params.p_f_w, params.endStoragePositionZ, params.p_b_w, params.p_l_w, params.p_r_w, params.p_u_t, params.p_u_c, params.cB_addStorage_left, params.cB_addStorage_check_left, params.cB_addStorage_right, params.cB_addStorage_check_right])

    const roofDirectionInfoArr = useMemo(() => {  
        let newDataArr = []
        frontBackModelPosYArr.map(index => {
            let isShowBackStorageBack = false;
            let isShowBackStorageFront = false;
            let isShowBackStorageRight = false;
    
            if (params.endStoragePositionZ !== 0) isShowBackStorageBack = true;
            if (params.endStoragePositionZ !== params.p_d - parseInt(params.p_u_t)) isShowBackStorageFront = true;
            if (params.p_r_w !== 'Close') isShowBackStorageRight = true;

            const dataArr = [
                {
                    direction: 'backStorageFront',
                    isShow: isShowBackStorageFront,
                    size: (params.p_w * (params.p_w * params.p_r_p / 12 - index) / (params.p_w * params.p_r_p / 12)) ,
                    angle: -Math.PI / 2,
                    pos_x: params.p_w / 2,
                    pos_z: -0.06,
                    end_pos_x: 0,
                    end_pos_z: -params.p_d / 2 + parseInt(params.p_u_t) - 0.15 + 0.1,
                },
                {
                    direction: 'backStorageBack',
                    isShow: isShowBackStorageBack,
                    size: (params.p_w * (params.p_w * params.p_r_p / 12 - index) / (params.p_w * params.p_r_p / 12)),
                    angle: -Math.PI / 2,
                    pos_x: params.p_w / 2,
                    pos_z: 0.06,
                    end_pos_x: 0,
                    end_pos_z: -params.p_d / 2 - 0.1,
                },
                {
                    direction: 'backStorageRight',
                    isShow: isShowBackStorageRight,
                    size: parseInt(params.p_u_t),
                    angle: 0,
                    pos_x: 0,
                    pos_z: -params.p_d / 2,
                    end_pos_x: params.p_w / 2 - 0.1,
                    end_pos_z: 0,
                },
  
                
            ] 
            newDataArr.push(dataArr)
        })
       
        return newDataArr;
    }, [params.p_w, params.p_d, params.p_f_w, params.p_b_w, params.endStoragePositionZ, params.p_l_w, params.p_r_w, params.p_u_t, params.cB_addStorage_left, params.cB_addStorage_right, params.p_r_p])
    
    /************** cutting hole using CSG ***************/    
    const CSGRailGroupArr = useMemo(() => {
        let dataArr = [];

        modelPosYArr.map(model_pos_y => {
            directionInfoArr.map(element => {
                if (element.isShow) {
                    const railModel = new THREE.Mesh(new THREE.ExtrudeGeometry(legModel, extrudeSettings(element.size)));
                    let tempRailModel = railModel.clone();
                    tempRailModel.position.set(element.pos_x, model_pos_y, element.pos_z);
                    tempRailModel.rotateY(element.angle);
                    tempRailModel.updateMatrix();
                    tempRailModel.updateMatrixWorld();

                    const meshLeftDelModel = CSG.toMesh(
                        meshDelModel_CSG.left,
                        new THREE.Matrix4(),
                        new THREE.MeshStandardMaterial({ color: 'blue' })
                    )

                    const meshRightDelModel = CSG.toMesh(
                        meshDelModel_CSG.right,
                        new THREE.Matrix4(),
                        new THREE.MeshStandardMaterial({ color: 'blue' })
                    )

                    const meshLeftDelModel_Temp = meshLeftDelModel.clone();
                    meshLeftDelModel_Temp.position.set(-params.p_w / 2 - 1.3, 0, 0 );
                    meshLeftDelModel_Temp.updateMatrix();
                    meshLeftDelModel_Temp.updateMatrixWorld();
            
                    const meshRightDelModel_Temp = meshRightDelModel.clone();
                    meshRightDelModel_Temp.position.set(params.p_w / 2 + 1.3, 0, 0 );
                    meshRightDelModel_Temp.updateMatrix();
                    meshRightDelModel_Temp.updateMatrixWorld();

                    const meshTempRailModel_CSG = CSG.fromMesh(tempRailModel);
                    const CSGMeshLeftDelModel = CSG.fromMesh(meshLeftDelModel_Temp);
                    const CSGMeshRightDelModel = CSG.fromMesh(meshRightDelModel_Temp);

                    let meshTempRailModel_CSG_Hole;
                    if(element.direction === 'backStorageBack'){
                        const frontMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                        const backMeshTempRailModel_CSG_Hole = frontMeshTempRailModel_CSG_Hole.subtract(meshLeftDelModel_Temp);
                        meshTempRailModel_CSG_Hole = backMeshTempRailModel_CSG_Hole.subtract(meshRightDelModel_Temp);
                        
                    } else if(element.direction === 'backStorageFront'){
                        const leftMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                        const rightMeshTempRailModel_CSG_Hole = leftMeshTempRailModel_CSG_Hole.subtract(CSGMeshLeftDelModel);
                        meshTempRailModel_CSG_Hole = rightMeshTempRailModel_CSG_Hole.subtract(CSGMeshRightDelModel);
                        
                    } else {
                        meshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                    }

                    const CSGRailModel = CSG.toMesh(
                        meshTempRailModel_CSG_Hole,
                        new THREE.Matrix4(),
                    )
                    dataArr.push({ direction: element.direction, CSGRailModel });
                }    
            })
        })
        
        return dataArr;
    }, [modelPosYArr, directionInfoArr, meshDelModel_CSG, legModel])

    const CSGFrontBackRailGroupArr = useMemo(() => {
      
        let dataArr = [];

        if (offset) {
            frontBackModelPosYArr.map((model_pos_y, index) => {
                roofDirectionInfoArr[index].map(element => {
                    if (element.isShow) {

                        const modelPosY = model_pos_y + (params.p_h - params.p_w * params.p_r_p / 12)
                        const leftStorageHeight = params.p_h - params.p_w * params.p_r_p / 12 + parseInt(params.cB_addStorage_left) * params.p_r_p / 12 - 0.2;
                        const rightStorageHeight = params.p_h - params.p_w * params.p_r_p / 12 + (params.p_w - parseInt(params.cB_addStorage_right)) * params.p_r_p / 12 - 0.2;

                        const railModel = new THREE.Mesh(new THREE.ExtrudeGeometry(legModel, extrudeSettings(element.size)));
                        let tempRailModel = railModel.clone();
                        tempRailModel.position.set(element.pos_x, modelPosY, element.pos_z);
                        tempRailModel.rotateY(element.angle);
                        tempRailModel.updateMatrix();
                        tempRailModel.updateMatrixWorld();

                        const meshLeftDelModel = CSG.toMesh(
                            meshDelModel_CSG.left,
                            new THREE.Matrix4(),
                            new THREE.MeshStandardMaterial({ color: 'blue' })
                        )
    
                        const meshRightDelModel = CSG.toMesh(
                            meshDelModel_CSG.right,
                            new THREE.Matrix4(),
                            new THREE.MeshStandardMaterial({ color: 'blue' })
                        )
    
                        const meshLeftDelModel_Temp = meshLeftDelModel.clone();
                        meshLeftDelModel_Temp.position.set(-params.p_w / 2 - 1.3, 0, 0 );
                        meshLeftDelModel_Temp.updateMatrix();
                        meshLeftDelModel_Temp.updateMatrixWorld();
                
                        const meshRightDelModel_Temp = meshRightDelModel.clone();
                        meshRightDelModel_Temp.position.set(params.p_w / 2 + 1.3, 0, 0 );
                        meshRightDelModel_Temp.updateMatrix();
                        meshRightDelModel_Temp.updateMatrixWorld();
    
                        const meshTempRailModel_CSG = CSG.fromMesh(tempRailModel);
                        const CSGMeshLeftDelModel = CSG.fromMesh(meshLeftDelModel_Temp);
                        const CSGMeshRightDelModel = CSG.fromMesh(meshRightDelModel_Temp);
    
                        let meshTempRailModel_CSG_Hole;
                        if(element.direction === 'backStorageBack'){
                            const frontMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                            const backMeshTempRailModel_CSG_Hole = frontMeshTempRailModel_CSG_Hole.subtract(meshLeftDelModel_Temp);
                            meshTempRailModel_CSG_Hole = backMeshTempRailModel_CSG_Hole.subtract(meshRightDelModel_Temp);
                            
                        } else if(element.direction === 'backStorageFront'){
                            const leftMeshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                            const rightMeshTempRailModel_CSG_Hole = leftMeshTempRailModel_CSG_Hole.subtract(CSGMeshLeftDelModel);
                            meshTempRailModel_CSG_Hole = rightMeshTempRailModel_CSG_Hole.subtract(CSGMeshRightDelModel);
                            
                        } else {
                            meshTempRailModel_CSG_Hole = meshTempRailModel_CSG.subtract(meshDelModel_CSG[element.direction]);
                        }
    
                        const CSGRailModel = CSG.toMesh(
                            meshTempRailModel_CSG_Hole,
                            new THREE.Matrix4(),
                        )
                        if (element.direction === 'leftStorageFront' || element.direction === 'rightStorageFront') {
                            if ((element.direction === 'leftStorageFront' && modelPosY <= leftStorageHeight) || (element.direction === 'rightStorageFront' && modelPosY <= rightStorageHeight)) {
                                dataArr.push({ direction: element.direction, CSGRailModel });
                            }
                        } else {
                            dataArr.push({ direction: element.direction, CSGRailModel });
                        }
                    }
                })
            })
        }
        
        return dataArr;
    }, [frontBackModelPosYArr, roofDirectionInfoArr, meshDelModel_CSG, legModel, params.p_w, params.p_h, params.p_r_p])
    
    /****************************************** **********/
    
    useMemo(() => {
        if((params.p_w * params.p_r_p / 12) > frontBackModelPosYArr[0]){
            setOffset(true)
        } else{
            setOffset(false)
        }
    }, [params.p_h, params.p_w, params.p_r_p]);
   
    return (
        <>
            <>
                <>
                    {CSGSideRailGroupModelArr.leftModelArr.map((item, index) =>
                        <group key={`pillar-rail-${index}`} renderOrder={2}>
                            <mesh name='outer' geometry={item.outer.geometry} position={[-(params.p_w / 2 - railHeight / 2), 0, 0]}>
                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                            </mesh>
                            {(const_var.legstype ==="double" || const_var.legstype === "ladder")?<mesh name='inner' geometry={item.inner.geometry} position={[-(params.p_w / 2 - railHeight / 2 - outInDistance), 0, 0]}>
                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                            </mesh>:null}
                        </group>
                    )}
                    {const_var.legstype === "ladder" && CSGSideRailGroupModelArr.leftConnectModelArr.map((item, index) =>
                        <mesh key={`connect-rail-${index}`} geometry={item.geometry} position={[-(params.p_w / 2 - railHeight / 2), 0, 0]}>
                             <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                        </mesh>
                    )}
                </>
                <>
                    {CSGSideRailGroupModelArr.rightModelArr.map((item, index) =>
                        <group key={`pillar-rail-${index}`}>
                            <mesh name='outer' geometry={item.outer.geometry} position={[(params.p_w / 2 - railHeight / 2), 0, 0]}>
                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                            </mesh>
                            {(const_var.legstype ==="double" || const_var.legstype === "ladder")?<mesh name='inner' geometry={item.inner.geometry} position={[(params.p_w / 2 - railHeight / 2 - outInDistance), 0, 0]}>
                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                            </mesh>:null}
                        </group>
                    )}
                    {const_var.legstype === "ladder" && CSGSideRailGroupModelArr.rightConnectModelArr.map((item, index) =>
                        <mesh key={`connect-rail-${index}`} geometry={item.geometry} position={[(params.p_w / 2 - railHeight / 2), 0, 0]}>
                            <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                        </mesh>
                    )}
                </>
            </>
            {(params.endStoragePositionZ !== 0) &&
                <group name='back-pillar' position={[0, 0, -params.p_d / 2]}>
                    {CSGFrontBackPillarRailModelArr.backModelArr.map((item, index_front) =>
                        <group key={`back-vertical-rail-${index_front}`}>
                            <mesh name= "backStorage_leg" geometry={item.geometry}>
                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                            </mesh>
                        </group>
                    )}
                    <mesh name='backStorage-bottom' geometry={CSGFrontBackBottomRailData.CSGBackBottomRailModel.geometry}>
                        <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                    </mesh>
                </group>
            }
            {(params.endStoragePositionZ !== params.p_d - parseInt(params.p_u_t)) &&
                <group name='backStorage-pillar' position={[0, 0, -params.p_d / 2 + parseInt(params.p_u_t)]}>
                    {CSGFrontBackPillarRailModelArr.backStorageModelArr.map((item, index_front) =>
                        <group key={`backStorage-vertical-rail-${index_front}`}>
                            <mesh name= "backStorage_leg" geometry={item.geometry}>
                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                            </mesh>
                        </group>
                    )}
                    <mesh name='backStorage-bottom' geometry={CSGFrontBackBottomRailData.CSGBackStorageBottomRailModel.geometry}>
                        <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                    </mesh>
                </group>
            }
            
            <group position={[0, -connerOffset, 0]}>
                {trussModelPosInfoArr.map((item_truss_pos_z, index_truss) => {
                    return (
                        <group key={`truss-model-${index_truss}`} position={[0, 0, item_truss_pos_z]}>
                            {new Array(2).fill('').map((_, index_invert) =>
                                {
                                    if(params.singleSlope && (params.freeStandingSide === "left" || params.freeStandingSide === "right") && index_invert === 1) return;
                                    return (
                                        <group key={`roof-rail-${index_invert}`} position={[Math.pow(-1, index_invert) * (roofRailData.pos_x), roofRailData.pos_y, 0]} rotation={[0, 0, Math.pow(-1, index_invert) * roofRailData.alpha]}>
                                            <mesh rotation={[0, Math.pow(-1, index_invert) * Math.PI / 2, 0]}>
                                                <extrudeGeometry args={[railModel(connectRailWidth, connectRailHeight), extrudeSettings(roofRailData.length - 0.1)]} />
                                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4}  />
                                            </mesh>
                                        </group>
                                    )
                                }
                            )}
                        </group>
                    )}
                )}
            </group>
            {params.p_v_w &&
                <group position={[0, -0.1, 0]}>
                    {CSGRailGroupArr.map((item, index) =>
                        <mesh
                            geometry={item.CSGRailModel.geometry}
                            position={[
                                directionInfoArr.find(child => child.direction === item.direction).end_pos_x,
                                0,
                                directionInfoArr.find(child => child.direction === item.direction).end_pos_z
                            ]}>
                           <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4} />
                        </mesh>
                        
                    )}
                    {params.singleSlope &&
                        CSGFrontBackRailGroupArr.map((item, index) =>
                            <mesh
                                geometry={item.CSGRailModel.geometry}
                                position={[
                                    directionInfoArr.find(child => child.direction === item.direction).end_pos_x,
                                    0,
                                    directionInfoArr.find(child => child.direction === item.direction).end_pos_z
                                ]}>
                                <meshPhongMaterial color={"#F0F0F0"} map={norMap} envMap={trussTexture} side={THREE.DoubleSide} reflectivity={0.4} />
                            </mesh>
                            
                        )
                    }
            </group>
        }
          
           
        </>
    )
}

export default Legs